/** Star appearance helpers for the catalogue starfield (S1-24). */

/** B−V colour index → effective temperature (Ballesteros 2012), K. */
export function bvToTemperature(bv: number): number {
  const c = Math.min(2, Math.max(-0.4, bv));
  return 4600 * (1 / (0.92 * c + 1.7) + 1 / (0.92 * c + 0.62));
}

/** Blackbody temperature → approximate sRGB in [0, 1] (Helland's fit), normalised so the brightest channel is 1. */
export function temperatureToRgb(kelvin: number): [number, number, number] {
  const t = kelvin / 100;
  let r: number, g: number, b: number;
  if (t <= 66) {
    r = 255;
    g = 99.4708025861 * Math.log(t) - 161.1195681661;
    b = t <= 19 ? 0 : 138.5177312231 * Math.log(t - 10) - 305.0447927307;
  } else {
    r = 329.698727446 * Math.pow(t - 60, -0.1332047592);
    g = 288.1221695283 * Math.pow(t - 60, -0.0755148492);
    b = 255;
  }
  const clamp = (v: number): number => Math.min(255, Math.max(0, v)) / 255;
  const rgb: [number, number, number] = [clamp(r), clamp(g), clamp(b)];
  const max = Math.max(...rgb);
  return [rgb[0] / max, rgb[1] / max, rgb[2] / max];
}

/** On-screen point size (CSS px) and opacity for a visual magnitude. */
export function starAppearance(mag: number): { size: number; alpha: number } {
  return {
    size: Math.min(6, Math.max(1.2, 4.5 - 0.55 * mag)),
    alpha: Math.min(1, Math.max(0.25, 1.25 - 0.13 * mag)),
  };
}
